import { MultilingualFactory } from '../../common';
export class ManfrediteCertificationFactory {
    static create(props = {}) {
        const defaultProps = {
            from: new Date('2023-03-21T14:40:09.874Z'),
            id: 1,
            issuingOrganization: 'My Organization',
            title: MultilingualFactory.create()
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 5) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=manfredite-certification.factory.js.map